import AOS from 'aos';
import 'aos/dist/aos.css';

class Loader {
    constructor() {
        const initAOS = () => {
            AOS.init({
                duration: 500,
                delay: 50,
                once: true,
                easing: 'cubic-bezier(0, 0, 0, 0.86)',
            });

            // TODO: refacto
            let illustrations = document.querySelectorAll('.illustration-draw, .illustration-draw--light');
            const scrollListen = () => {
                if (illustrations.length) {
                    illustrations.forEach((ill) => {
                        const { bottom } = ill.getBoundingClientRect();
                        if (bottom < window.innerHeight + 60) {
                            ill.style.clipPath = "circle(100%)"; // eslint-disable-line
                            illustrations = Array.from(illustrations).filter((i) => i !== ill);
                        }
                    });
                }
            };

            setInterval(scrollListen, 500);
            window.addEventListener('scroll', scrollListen);
        };

        setTimeout(() => {
            const loader = document.getElementById('loader');
            loader.children[0].style.transform = 'translateX(100%)';
            loader.children[1].classList.replace('opacity-100', 'opacity-0');

            setTimeout(() => {
                loader.style.display = 'none';
            }, 500);

            const line = document.querySelector('.homeBanner__button');

            setTimeout(() => {
                initAOS();
                if (line) {
                    setTimeout(() => {
                        line.style.clipPath = 'polygon(0 0, 100% 0, 100% 100%, 0 100%)';
                    }, 750);
                }
            }, 500);
        }, 500);
    }
}

export default Loader;
